import { render } from "./CreateCategoryModal.vue?vue&type=template&id=60f82492&scoped=true"
import script from "./CreateCategoryModal.vue?vue&type=script&lang=js"
export * from "./CreateCategoryModal.vue?vue&type=script&lang=js"

import "./CreateCategoryModal.vue?vue&type=style&index=0&id=60f82492&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60f82492"]])

export default __exports__